import { vysePoplatku } from 'helpers/contract/vysePoplatku';
import { Date, Money } from 'modules';
import React, { useMemo } from 'react';
import PlaceSignature from '../components/PlaceSignature';
import { bonatoCompany } from 'constants/company';

interface Content202210Props {
  contract: GQL.IContract;
  form: GQL.IContractOnlineForm;
}

const Content202210 = ({ contract, form }: Content202210Props) => {
  const provozovna = useMemo(() => contract?.provozovna, [contract]);

  return (
    <>
      <div className="mb-3 text-center">
        <strong>OBJEDNÁVKA NA ODDLŽENIE BONATO č. {contract?.cislo}</strong>
      </div>

      <div className="mb-3">
        DODÁVATEĽ:
        <br />
        <strong>{bonatoCompany.name}</strong>
        <br />
        so sídlom {provozovna?.ulice}, {provozovna?.psc} {provozovna?.mesto}
        <br />
        korešpondenčná adresa <strong>{bonatoCompany.contactAddress}</strong>
        <br />
        IČO: {provozovna?.ico}, DIČ: {provozovna?.dic}
        <br />
        {provozovna?.zalozeno}
        <br />
        {bonatoCompany.ceo}, konateľ
      </div>

      <div className="mb-3">
        OBJEDNÁVATEĽ:
        <br />
        Meno a priezvisko:{' '}
        <strong>
          {contract?.prijmeni} {contract?.jmeno}
        </strong>
        <br />
        trvale bytom: {contract?.ulice} {contract?.cislo_popisne}, {contract?.mesto}, {contract?.psc}
        <br />
        dátum narodenia: {contract?.rc}
        <br />
        telefonický kontakt: {contract?.mobil}
        <br />
        e-mail: {contract?.email}
      </div>

      <div className="mb-2 text-center">
        <strong>Predmetom tejto objednávky je Oddlženie BONATO</strong>
      </div>
      <div className="mb-3">
        <div className="mb-2">
          Na základe telefonickej on – line konzultácie s Oddlžovacím poradcom si objednávam u BONATA s.r.o. Oddlženie
          BONATO.
        </div>
        <div className="mb-2">Oddlženie BONATO obsahuje:</div>
        <p className="paragraph">
          Analýzu životnej, finančnej a majetkovej situácie objednávateľa, kontrolu dlhov voči štátu a štátnym
          inštitúciám, kontrolu v registri exekúcií. Podľa tejto analýzy vypracuje BONATO písomný posudok, ktorý
          obsahuje aj výber najvhodnejšieho variantu Oddlženia BONATO pre objednávateľa. Tento posudok sa zaväzuje
          {bonatoCompany.name} vypracovať do 7 dní od pripísania sumy na účet {bonatoCompany.name}. O vyhotovení posudku
          bude objednávateľ informovaný SMS správou na hore uvedené telefónne číslo.
        </p>
      </div>

      <div className="mb-2 text-center">
        <strong>Varianty Oddlženia BONATO</strong>
      </div>
      <div className="mb-3">
        Prvý Variant je:
        <br />
        <strong>
          <u>Osobný bankrot s možnosťou podať žiadosť na Centrum právnej pomoci ihneď.</u>
        </strong>{' '}
        U tohto variantu vystaví BONATO objednávateľovi <u>GARANCIU</u> schválenia žiadosti miestne príslušným súdom. Po
        doručení podkladov, potrebných k vypracovaní tejto žiadosti objednávateľom pridelenému pracovníkovi BONATO
        s.r.o. sa dodávateľ zaväzuje do 7 pracovných dní doručiť Objednávateľovi na jeho korešpondenčnú adresu, ktorú
        uviedol pri uzavretí tejto objednávky, kompletne vypracovanú žiadosť na Osobný bankrot k podpisu spolu s
        potrebnými pokynmi. Objednávateľ sa zaväzuje bez zbytočného odkladu túto žiadosť skontrolovať a podpísanú podľa
        pokynov zaslať spať na adresu:
        <br />
        <div className="ml-4">
          <strong>
            {bonatoCompany.name}
            <br />
            {bonatoCompany.contactAddressLine1}
            <br />
            {bonatoCompany.contactAddressLine2}
          </strong>
        </div>
        a to doporučenou poštou.
        <br />
        <p className="paragraph">
          BONATO túto žiadosť po záverečnej kontrole pošle na svoje náklady na Centrum právnej pomoci za Objednávateľa.
        </p>
        <p className="paragraph">
          Túto žiadosť sa zaväzuje BONATO vypracovať pre Objednávateľa <u>zdarma</u>.
        </p>
      </div>
      <div className="mb-3">
        Druhý variant je:
        <br />
        <strong>
          <u>
            Osobný bankrot s možnosťou podať žiadosť na Centrum právnej pomoci až po splnení zákonom požadovaných
            podmienok (Odklad podania).
          </u>
        </strong>{' '}
        To znamená, že nemôžeme podať žiadosť o osobný bankrot ihneď a musíme počkať určitú dobu, kedy objednávateľ
        tieto podmienky splní. Základnou podmienkou je trvanie exekúcie minimálne 1 rok. Aj u tohto variantu vystaví
        BONATO objednávateľovi <u>GARANCIU</u> schválenia žiadosti súdom a tým sa objednávateľ oddlží.
        <br />
        <p className="paragraph">
          BONATO sa zaväzuje informovať objednávateľa o faktu, že už tieto zákonom dané podmienky spĺňa a po doručení
          podkladov, potrebných k vypracovaní tejto žiadosti objednávateľom pridelenému pracovníkovi{' '}
          {bonatoCompany.name} sa dodávateľ zaväzuje do 7 pracovných dní doručiť Objednávateľovi na jeho korešpondenčnú
          adresu, ktorú uviedol pri uzavretí tejto objednávky, kompletne vypracovanú žiadosť na Osobný bankrot k podpisu
          spolu s potrebnými pokynmi. Objednávateľ sa zaväzuje bez zbytočného odkladu túto žiadosť skontrolovať a
          podpísanú podľa pokynov zaslať spať na Adresu:
        </p>
        <div className="ml-4">
          <strong>
            {bonatoCompany.name}
            <br />
            {bonatoCompany.contactAddressLine1}
            <br />
            {bonatoCompany.contactAddressLine2}
          </strong>
        </div>
        a to doporučenou poštou.
        <br />
        BONATO túto žiadosť po záverečnej kontrole pošle na svoje náklady na Centrum právnej pomoci za Objednávateľa.
        <br />
        Túto žiadosť sa zaväzuje BONATO vypracovať pre Objednávateľa <u>zdarma</u>.
      </div>
      <div className="mb-3">
        Tretí variant je:
        <br />
        <strong>
          <u>Správa záväzkov.</u>
        </strong>{' '}
        Osobný bankrot by Objednávateľovi súd neschválil a preto u tohto variantu nemôže BONATO objednávateľovi vystaviť
        GARANCIU schválenia žiadosti na Osobný bankrot sudom. Po dodaní kompletných zmlúv, na základe ktorých dlhy
        Objednávateľa vznikli Objednávateľom poverenému pracovníkovi {bonatoCompany.name} vytvorí Dodávateľ „Návrh
        riešenia na Správu záväzkov“.
        <br />
        <p className="paragraph">
          Tento návrh riešenia sa {bonatoCompany.name} zaväzuje vytvoriť do 7 dní o čom bude objednávateľ informovaný
          SMS správou na hore uvedené tel. číslo. Po dodaní „Návrhu riešenia“ sa Objednávateľ rozhodne či uzavrie Zmluvu
          o správe záväzkov na základe ktorej bude Objednávateľ oddlžovaný postupným splácaním svojich dlhov pomocou
          {bonatoCompany.name} a jeho spolupracujúcich subjektov.
        </p>
        <p className="paragraph">
          Návrh riešenia sa zaväzuje BONATO vypracovať <u>zdarma</u>.
        </p>
      </div>

      <div className="mb-2 text-center">
        <strong>I. ODMENA DODÁVATEĽA:</strong>
      </div>
      <div className="mb-2">
        Dodávateľ a objednávateľ sa dohodli na odmene{' '}
        <strong>
          vo výške <Money value={vysePoplatku(contract)} />
        </strong>
        .
      </div>
      <div className="mb-3">
        Táto odmena je za vypracovaný posudok, ktorý obsahuje analýzu životnej, finančnej a majetkovej situácie
        objednávateľa, kontrolu dlhov voči štátu a štátnym inštitúciám, lustráciu v registri exekúcií a výber
        najvhodnejšieho variantu Oddlženia BONATO pre objednávateľa a u prvých dvoch variantov aj vystavenie garancie
        schválenia oddlženia sudom.
        <br />
        Všetky ďalšie kroky vyplývajúce z vybraného variantu Oddlženia BONATO sú <u>zdarma</u>.
      </div>

      <div className="mb-2 text-center">
        <strong>II. SPLATNOSŤ ODMENY OBJEDNÁVATEĽA:</strong>
      </div>
      <div className="mb-2">
        <p className="paragraph">
          Dodávateľ a objednávateľ sa dohodli, že ODMENA vo výške <Money value={vysePoplatku(contract)} />{' '}
          {/*(tristopäťdesiat)*/} bude splatná po podpise objednávky a to prevodom, vkladom alebo on-line platbou v
          On-line sekcii dodávateľa a to najneskôr do{' '}
          <Date value={contract?.spravaDluhu?.prvni_platba_termin?.toString()} /> na bankový účet dodávateľa. Oddlžovací
          poradca dodávateľa sa môže s objednávateľom dohodnúť na úhrade a splatnosti odmeny v dvoch splátkach,
          objednávateľ však berie na vedomie, že posudok s výberom najvhodnejšieho variantu bude odovzdaný v kancelárií
          obchodného zástupcu, zaslaný na emailovú adresu objednávateľa, doporučene poštovou zásielkou na poskytnutú
          korešpondenčnú adresu objednávateľa alebo v sekcii On-line dodávateľa až potom, ako bude zo strany
          objednávateľa uhradená odmena v plnom rozsahu.
        </p>
      </div>
      <div className="mb-3">
        Bankový účet DODÁVALEĽA je vedený u Poštová banka, a.s.
        <br />
        <strong>SK49 8330 0000 0023 0266 1356</strong>,<br />
        variabilný symbol: <strong>{contract?.cislo}</strong>
        <br />
        špecifický symbol: <strong>{contract?.rc?.replace('/', '')}</strong>
      </div>

      <div className="mb-2 text-center">
        <strong>III. DÔLEŽITÉ UPOZORNENIE</strong>
      </div>
      <div className="mb-5">
        <p className="paragraph">
          Dodávateľ a objednávateľ sa dohodli, že vypracovaný posudok s výberom variantu bude objednávateľovi odovzdaný
          v kancelárii BONATO s.r.o, v ktorej došlo k podpisu objednávky na Oddlženie BONATO po splnení vyššie uvedených
          podmienok a po uhradení odmeny v plnom rozsahu.
        </p>
        <p className="paragraph">
          Objednávateľ berie na vedomie, že pokiaľ nedôjde z jeho strany k prevzatiu posudku na základe výzvy dodávateľa
          v kancelárii {bonatoCompany.name}, dodávateľ je oprávnený zaslať tento Posudok na poskytnutú emailovú adresu,
          v prípade, ak objednávateľ nemá emailovú adresu, alebo ju neposkytol, dodávateľ je oprávnený zaslať toto
          Posudok doporučene poštovou zásielkou na poskytnutú korešpondenčnú adresu objednávateľa.
        </p>
        <p className="paragraph">
          Ak však ide o online objednávku, Posudok bude objednávateľovi zaslaný na uvedenú emailovú adresu. Objednávateľ
          a poverený pracovník dodávateľa sa môžu dohodnúť, akým spôsobom bude Posudok objednávateľovi odovzdaný. Zo
          strany dodávateľa je objednávka splnená v plnom rozsahu odovzdaním posudku v kancelárii {bonatoCompany.name},
          alebo zaslaním posudku na emailovú adresu alebo doporučene poštovou zásielkou na korešpondenčnú adresu.
        </p>
        <p className="paragraph">
          V prípade, ak sa Oddlžovací poradca dohodol s objednávateľom na úhrade a splatnosti úhrady odmeny v dvoch
          splátkach, pokiaľ zo strany objednávateľa nedôjde k úhrade prvej časti odmeny v zmysle tejto objednávky v
          stanovenom termíne, objednávateľ nemá nárok na odovzdanie posudku a objednávka zanikne neuhradením prvej časti
          odmeny v stanovenom termíne.
        </p>
      </div>
      <PlaceSignature contract={contract} form={form} />
    </>
  );
};

export default Content202210;
